// extracted by mini-css-extract-plugin
export var container = "_b8-1";
export var cornerButtonContainer = "_b8-5";
export var disabled = "_b8-2";
export var fileContainer = "_b8-4";
export var hiddenInput = "_b8-3";
export var widthContainer = "_b8-0";